import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ConsultationType, ConsultationStep, ConsultationStepInfo, GroupConsultationStep, GroupConsultationStepInfo } from './../../../models/consultation/consultation.model';
import { Router } from '@angular/router';
import { ConsultationStatusService } from './consultation-status.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { Utility } from '../../../common/utility';
import * as moment from 'moment';
import { AddToGroupTemplatePopupComponent } from '../waiting-room/group-template/add-to-group-template-popup.component';

@Component({
    selector: 'consultation-status',
    templateUrl: 'consultation-status-popup.html',
    providers: [ConsultationStatusService]
})

export class ConsultationStatusPopupComponent implements OnInit {
    public isNewConsulation = true;
    public usertype = '';
    public consultationType = ConsultationType;
    constructor(
        private dialogService: DialogService,
        public consultationStatusService: ConsultationStatusService,
        private router: Router,
        public dialogRef: MdDialogRef<ConsultationStatusPopupComponent>,
        @Inject(MD_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        this.usertype = localStorage.getItem(AppConstants.localStorage.userType);
    }


    onCloseDialog(isNewConsulation = false) {
        this.dialogRef.close(isNewConsulation);
    }

    onNewConsultation() {
        this.isNewConsulation = false;
    }

    onContinueConsultation() {
        if (this.data.isIndividual) {
            if (this.data.status === this.consultationType.InConsultation) {
                // move to the latest step in consultation process
                const consultationStep = ConsultationStepInfo.filter(c => c.step === this.data.lastedStep);
                if (consultationStep.length > 0) {
                    this.router.navigate([consultationStep[0].routerLink, this.data.id, this.data.userId]);
                }
            } else {
                this.router.navigate([ConsultationStepInfo[0].routerLink, this.data.id, this.data.userId]);
            }
        }
        if (this.data.isGroup) {
            if (this.data.status === this.consultationType.Consultation) {
                //  move to the navigate to Trip Information page
                this.router.navigate([GroupConsultationStepInfo[0].routerLink, this.data.id]);
            } else {
                // move to the latest step in consultation process
                const groupConsultationStep = GroupConsultationStepInfo.filter(c => c.step === this.data.lastedStep);
                if (groupConsultationStep.length > 0) {
                    this.router.navigate([groupConsultationStep[0].routerLink, this.data.id]);
                }
            }
        }
        this.onCloseDialog();
    }

    onConfirmNewConsultation() {
        // Navigate to patient detail page
        if (this.data.isIndividual) {
            // CR01 show confirm popup
            const message = Utility.stringFormat(AppMessages.consultationStatus.clearConsultation, [this.data.name, moment(this.data.dateOfBirth).format(AppConstants.dateConfig.date)]);
            this.dialogService.openConfirmationDialog({ message: message }).subscribe(
                (confirm) => {
                    if (confirm) {
                        this.consultationStatusService.newConsultation(this.data.userId, this.data.id).subscribe(
                            (result) => {
                                if (result) {
                                    const id = result.json().id;
                                    //this.router.navigate([ConsultationStepInfo[0].routerLink, id, this.data.userId]);
                                    this.onCloseDialog(true);
                                }
                            }
                        );
                    }
                }
            );
        }
    }

    onAdministerVaccine() {
        if (this.data.status === this.consultationType.AdministerVaccine || this.data.status === this.consultationType.InAdministerVaccine) {
            // router centre administer vaccine page Individual Consulation
            this.router.navigate([ConsultationStepInfo[9].routerLink, this.data.id, this.data.userId]);
        }/*  else if (this.data.status === this.consultationType.InAdministerVaccine) {
            const consultationStep = ConsultationStepInfo.filter(c => c.step === this.data.lastedStep);
            if (consultationStep.length > 0) {
                this.router.navigate([consultationStep[0].routerLink, this.data.id, this.data.userId]);
            }
        } */
        this.onCloseDialog();
    }

    onConsultationOnly() {
        this.consultationStatusService.moveToConfirmLabtest(this.data.id).subscribe(
            (result) => {
                if (result) {
                    this.router.navigate([ConsultationStepInfo[10].routerLink, this.data.id, this.data.userId]);
                    this.onCloseDialog();
                }
            }, (error) => {
              this.onCloseDialog();
            });
        // router confirmation lab test page  Individual Consulation
    }

    onInvoice() {
        // if status is Invoice then redirect to cashsale page
        this.consultationStatusService.createConsultationInvoice(this.data.id).subscribe(
            (result) => {
                if (result) {
                    this.router.navigate(['consultation/cash-sale/', this.data.id, this.data.userId]);
                    this.onCloseDialog();
                }
            }
        );

    }

    onLabTest() {
        // Navigate to confirmation lab tests page Individual Consulation
        this.router.navigate([ConsultationStepInfo[7].routerLink, this.data.id, this.data.userId]);
        this.onCloseDialog();
    }

    /**
     * function to add a patient to a group template
     */
    onAddToGroupTemplate() {
        const data = {
            consultationId: this.data.id
        };
        this.dialogService.openComponentDialog(AddToGroupTemplatePopupComponent, data, { 'width': '500px' }).subscribe
            (result => {
                if (result) {
                    this.onCloseDialog(true);
                }
            });
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/consultation-status/consultation-status-popup.ts